import { Navigate, useLocation, useParams } from 'react-router-dom';

export const SearchRedirect = () => {
  const { tenantShortName } = useParams();
  const { search } = useLocation();

  return <Navigate to={`/tenants/${tenantShortName}/assets${search}`} replace />;
};
